import { createSlice } from "@reduxjs/toolkit";
import { FilterStateStoresRegional } from "./types";
import { getPreviousDay } from "../../../../../utils/previousDay";

const INITIAL_STATE: FilterStateStoresRegional = {
  filters: {
    date: getPreviousDay(),
    meta: {
      page: 1,
    },
  },
};

const filterRegionalSlice = createSlice({
  name: "filter",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
    resetFilters(state) {
      state.filters = INITIAL_STATE.filters; 
    },
  },
});

export const { setFilter, resetFilters } = filterRegionalSlice.actions;
export default filterRegionalSlice.reducer;
